"use client";

import cn from "@utils/cn";
import { getQuarter } from "@utils/dateUtils";
import { DEFAULT_CURRENCY } from "@utils/default";
import { getCookie } from "cookies-next";
import { useSession } from "next-auth/react";
import { useTranslations } from "next-intl";
import { useEffect, useState } from "react";

import { NotificationType } from "@/components/NotificationProvider/type";
import Button, { ButtonSize, ButtonTheme, ButtonVariant } from "@/components/ui/Button/Button";
import Icon from "@/components/ui/Icon/Icon";
import { ctaClickTracking, ecomAddToWishlist } from "@/dataLayer/dataLayer";

type AddToFavoritesProps = {
  className?: string;
  fillColor?: string;
  item: any;
  setTransparent?: boolean;
  cta?: boolean;
};

export default function AddToFavorites({ className, fillColor = "fill-white", item, setTransparent, cta }: AddToFavoritesProps) {
  const [addToFavorite, setAddToFavorite] = useState(false);
  const { data: session } = useSession();
  const t = useTranslations();

  const handleClick = async () => {
    let success: boolean;
    if (!addToFavorite) {
      ecomAddToWishlist({
        property_name: item.project || item.project,
        project_location: item.location,
        project_type: item.unitType || item.propertyType || "",
        bedroom_numbers: item.bedrooms || "1",
        unit_type: item.isFurnished ? "furnished" : "unfurnished",
        unit_size: Math.round(item.areaSqft) || item.areaMin,
        unit_price: item.price || Math.round(Number(item.priceMin) / 100),
        currency: getCookie("currency") ?? DEFAULT_CURRENCY,
        posession_time: getQuarter(item.deliveryDate),
        user_logged_in: !!session,
        // user_id: session?.user.id || "",
      });
    } else {
      // success = await deleteFavorites([item]);
    }
    // success && setAddToFavorite(!addToFavorite);

    ctaClickTracking("Add To Favorites", "AddToFavorites", "Add to favorite");
  };

  // useEffect(() => {
  //   setAddToFavorite(isAdded);
  // }, [isAdded, isFavorite, item.id]);

  const iconSize = setTransparent ? "16" : "24";

  return cta ? (
    <Button
      rounded
      size={ButtonSize.MEDIUM}
      theme={ButtonTheme.BLACK}
      type="button"
      variant={ButtonVariant.PRIMARY}
      customClass="md:!px-xl w-[calc(100%-32px)]  mx-auto md:w-auto"
      onClick={handleClick}
    >
      {t("label.common.addUnitToShortlist")}
    </Button>
  ) : (
    <div className={className}>
      <Button
        size={ButtonSize.SMALL}
        variant={ButtonVariant.PRIMARY}
        theme={ButtonTheme.WHITE}
        onClick={handleClick}
        className={cn(
          "stroke-black  overflow-hidden",
          setTransparent && "bg-white shadow md:bg-transparent md:box-material-primary md:stroke-white !rounded-full p-xxs",
        )}
      >
        <span className="flex items-center gap-xs ">
          <Icon fill={addToFavorite ? fillColor : ""} name="heart-empty" size={iconSize} title="Add to favorite" />
        </span>
        <span className="sr-only">{t("label.common.addToFavorites")}</span>
      </Button>
    </div>
  );
}
